menu:
  - id: news
    href: "#news"
    label:
      en: News
      ja: ニュース
  - id: research
    href: "#research"
    label:
      en: Research
      ja: 研究
  - id: career
    href: "#career"
    label:
      en: Career
      ja: 経歴
  - id: education
    href: "#education"
    label:
      en: Education
      ja: 学歴
  - id: publication
    href: "#publication"
    label:
      en: Publication
      ja: 業績
  - id: talks
    href: "#talks"
    label:
      en: Talks
      ja: 講演
  - id: award
    href: "#award"
    label:
      en: Award
      ja: 受賞等
  - id: creation
    href: "#creation"
    label:
      en: Creation
      ja: 作品
  - id: others
    href: "#others"
    label:
      en: Others
      ja: その他
  - id: contact
    href: "#contact"
    label:
      en: Contact
      ja: 連絡先
  - id: note
    href: "/note"
    label:
      en: Note
      ja: 雑記
    className: mt-5
